<div class=" my-5">
  <footer class="text-center text-lg-start text-white classFooter" style="background-color: #BF1E2E">
    <section class="">
      <div class="container py-3 text-center text-md-start">
        <div class="row mt-3 justify-content-between" style="flex-wrap: none !important;">
          <div class="col-md-3 col-lg-4 col-xs-12  text-start">
            <h6 class="fw-bold">Subscribe to our Newsletter</h6>
            <div class="input-group">

              <input type="search" class="form-control new-inp mr-2" [(ngModel)]="emailN" maxlength="50"
                (keypress)="preventSpace($event)" placeholder="Enter email here" aria-label="Search"
                aria-describedby="search-addon" />

              <button type="button" class="btn  btn-bnew" [disabled]="isEmailValid()"
                (click)="getDeals()">Subscribe</button>
            </div>
            <div class="mt-4 text-align-left socialIconBox"
              style="text-align: left; display: flex; align-items: center; gap: 15px;">
              <a href="https://facebook.com/exobe.africa" target="_blank" class="data-icon" style="font-size: 24px; ">
                <i class="fa fa-facebook-f"></i>
              </a>
              <a href="https://twitter.com/exobe" target="_blank" class="data-icon" style="font-size: 24px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.901 1.153h3.68l-8.04 9.557L24 22.846h-7.406l-5.8-7.584-6.638 7.584H1.128l8.659-9.928L0 1.153h7.594l5.243 6.932L18.901 1.153zm-1.626 19.831h2.039L6.882 3.257H4.697L17.275 20.984z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/exobe.africa" target="_blank" class="data-icon" style="font-size: 24px; 
              ">
                <i class="fa fa-instagram"></i>
              </a>
              <a href="https://pinterest.com/exobe" target="_blank" class="data-icon" style="font-size: 24px;">
                <i class="fa fa-pinterest"></i>
              </a>

              <a href="https://www.tiktok.com/exobe" target="_blank" class="data-icon" style="font-size: 24px; ">
                <i class="fa fa-tiktok"></i>
              </a>

            </div>
          </div>
          <div class="col-6 col-sm-6 col-md-2 col-lg-2 text-start">

            <h6 class="fw-bold special-tab">Explore</h6>
            <p>
              <a href="#" [ngClass]="{ active: currUrl == 'terms-and-condition' }" 
                (click)="showDocumentContent('termsConditions', $event)" class="text-white">Terms & Conditions</a>
            </p>
            <p>
              <a href="#" [ngClass]="{ active: currUrl == 'privacy-policy' }" 
                (click)="showDocumentContent('privacyPolicy', $event)" class="text-white">Privacy Policy</a>
            </p>
            <p>
              <a href="#" [ngClass]="{ active: currUrl == 'aboutUs' }" 
                (click)="showDocumentContent('aboutUs', $event)" class="text-white">About Us</a>
            </p>

          </div>
          <div class="col-6 col-sm-6 col-md-3 col-lg-2 text-start">


            <h6 class="fw-bold special-tab">Help</h6>
            <p>
              <a href="#" [ngClass]="{ active: currUrl == 'faq' }" 
                (click)="showDocumentContent('faq', $event)" class="text-white">FAQ's</a>
            </p>
            <p>
              <a [ngClass]="{ active: currUrl == 'contactUs' }" routerLink="/contactUs" class="text-white">Contact
                Us</a>
            </p>
            <p>
              <a [ngClass]="{ active: currUrl == 'referal' }" routerLink="/referal" class="text-white">Refer Now</a>
            </p>

          </div>
        </div>
      </div>
    </section>
  </footer>
</div>

<!-- Document Modal Component -->
<app-document-modal></app-document-modal>
